import { captureError } from "@outschool/platform";

/**
 * Object returned by IP lookup call to maxmind DB
 * It restricts the number of properties returned
 * Note that this logic is duplicated in lang-js/apps/iplookup/src/geo-data.ts
 * Changes to these types should be done in both places.
 **/

export type Subdivision = {
  isoCode: string;
  names: {
    en: string;
  };
};

export type GeoData = {
  ip: string;
  city: {
    names: { en: string };
  };
  location: { timezone: string };
  country: {
    isoCode: string;
    names: { en: string };
    isInEuropeanUnion: boolean | undefined;
  };
  // this is an array for backwards compatibility, will only have 1 element
  subdivisions: Subdivision[];
  postal: { code: string };
};

// import * as Sentry from "../../shared/client/Sentry";

export async function getIPLookup({
  iplookupApiBaseUrl,
  iplookupApiKey,
  ip,
  fetchFn,
}: {
  iplookupApiBaseUrl: string;
  iplookupApiKey: string;
  ip?: string;
  fetchFn: (input: RequestInfo, init?: RequestInit) => Promise<Response>;
}): Promise<GeoData | null> {
  try {
    let url = `https://${iplookupApiBaseUrl}/lookup?token=${iplookupApiKey}`;
    if (ip) {
      url += `&ip=${ip}`;
    }
    const response = await fetchFn(url);
    const data = await response.json();
    return data as GeoData;
  } catch (err) {
    if (err instanceof SyntaxError) {
      captureError(new Error("Invalid JSON response from IP lookup API"), {
        extra: {
          response: err.message,
        },
      });
      return null;
    }
    throw err;
  }
}

/**
 * The raw response type returned by getIPLookup
 */
export type IPLookupResponse = GeoData;
